import dayjs from 'dayjs';

const CatchAll = () => (
  <div
    style={{
      padding: 24,
      background: '#fff',
      minHeight: 360,
    }}
  >
    <div
      style={{
        paddingLeft: 0,
        borderBottom: '1px solid rgb(235, 237, 240)',
        marginBottom: 16,
      }}
      title='MyCorpManager'
    />
    <strong>Page not found</strong>
    <br />
    MyCorpManager ©{dayjs().format('YYYY')}
  </div>
);

export default CatchAll;
